import { optimismSepolia } from 'viem/chains';

export const DEFAULT_CHAIN = optimismSepolia;
export const PROJECT_ID = '45b75ad086285fcbfb457b8ab0a94f1c';
export const WORLDCOIN_APP_ID = 'app_staging_1960971445b5b83af1cd3c30d82eb246';
